import { useRef } from 'react';

import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
} from '@chakra-ui/react';

import { RetryDeductionsReportDialogProps } from './types';

/** Asks an admin to confirm before a failed company deductions report is generated again. */
function RetryDeductionsReportDialog({
  isOpen,
  isRetrying,
  onClose,
  onConfirm,
}: RetryDeductionsReportDialogProps) {
  const cancelRef = useRef<HTMLButtonElement>(null);

  return (
    <AlertDialog
      isOpen={isOpen}
      leastDestructiveRef={cancelRef}
      onClose={onClose}
      closeOnOverlayClick={!isRetrying}
      closeOnEsc={!isRetrying}
    >
      <AlertDialogOverlay>
        <AlertDialogContent data-testid="retry-deductions-report-dialog">
          <AlertDialogHeader>Retry report</AlertDialogHeader>
          <AlertDialogBody>
            Generate this deduction report again? The failed attempt and its files will be kept.
          </AlertDialogBody>
          <AlertDialogFooter>
            <Button
              ref={cancelRef}
              variant="outline"
              onClick={onClose}
              isDisabled={isRetrying}
              data-testid="cancel-retry-deductions-report-button"
            >
              Cancel
            </Button>
            <Button
              ml="12px"
              onClick={onConfirm}
              isLoading={isRetrying}
              data-testid="confirm-retry-deductions-report-button"
            >
              Retry
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  );
}

export default RetryDeductionsReportDialog;
